import { Box, Grid } from '@mui/material';

import { ScoreType } from '@/domain/impact/impact.entity';
import { selectTopicsGlobaScoreDataForProject } from '@/domain/impact-calculate/impact-calculate.selectors';
import { ProjectAbstract } from '@/domain/project/entities/project.entity';
import { useAppSelector } from '@/ui/hook/store';

import { ProjectScoreCard } from './components/ProjectScoreCard';
import { prepareScoreCardData } from './utils/prepare-score-card-data';

export const ShowDetailsModesValues = ['none', 'co2', 'ess', 'env'] as const;
export type ShowDetailsMode = (typeof ShowDetailsModesValues)[number];

interface IProps {
  project: ProjectAbstract;
  onClickScore?: (type: ScoreType) => void;
  showDetailsMode: ShowDetailsMode;
}

export function ProjectScores({
  project,
  showDetailsMode,
  onClickScore,
}: IProps) {
  const topicsGlobalScoreData = useAppSelector(
    selectTopicsGlobaScoreDataForProject(project.id),
  );
  const data = prepareScoreCardData(topicsGlobalScoreData, showDetailsMode);
  return (
    <Box>
      <Grid container spacing={3}>
        {data.map((x) => (
          <Grid key={x.type} item xs={12} md={6} lg={4}>
            <ProjectScoreCard
              scoreTitle={x.scoreTitle}
              scoreIcon={x.scoreIcon}
              scoreTextColor={x.scoreTextColor}
              scoreBackgroundColor={x.scoreBackgroundColor}
              resultValue={x.resultValue}
              resultUnit={x.resultUnit}
              resultSecondLine={x.resultSecondLine}
              infos={x.infos}
              selected={x.selected}
              onClick={onClickScore ? () => onClickScore(x.type) : undefined}
              scoreLetter={x.scoreLetter}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
